(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["giftiliya-order-journey"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('giftiliya-journey')){customElements.define('giftiliya-journey',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.timers=[];const steps=Array.from(this.querySelectorAll('.gjw-step'));this.reduce=matchMedia('(prefers-reduced-motion: reduce)');const play=()=>{this.timers.forEach(clearTimeout);steps.forEach(s=>s.classList.remove('is-active','is-past'));if(this.reduce.matches){steps.forEach(s=>s.classList.add('is-past'));return;}steps.forEach((step,index)=>this.timers.push(setTimeout(()=>{steps.forEach((s,i)=>{s.classList.toggle('is-active',i===index);s.classList.toggle('is-past',i<index);});},300+index*1800)));this.timers.push(setTimeout(()=>steps.forEach(s=>{s.classList.remove('is-active');s.classList.add('is-past');}),7800));};this.onMotion=play;this.reduce.addEventListener('change',play);this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){play();this.observer.disconnect();}},{threshold:.3});this.observer.observe(this);}disconnectedCallback(){this.timers?.forEach(clearTimeout);this.observer?.disconnect();this.reduce?.removeEventListener('change',this.onMotion);this.ready=false;}});}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["giftiliya-promise"] && !Shopify.designMode) return;
  try {
    (() => {
  const setup = () => {
    document.querySelectorAll('.giftiliya-promise:not([data-ready])').forEach(root => {
      root.dataset.ready = 'true';
      if (!('IntersectionObserver' in window)) { root.classList.add('is-visible'); return; }
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { root.classList.add('is-visible'); observer.disconnect(); }
      }, { threshold: 0.15 });
      observer.observe(root);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true}); else setup();
  document.addEventListener('shopify:section:load', setup);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["giftiliya-trust"] && !Shopify.designMode) return;
  try {
    (()=>{const init=(root=document)=>{root.querySelectorAll('.gft:not([data-gft-init])').forEach(el=>{el.dataset.gftInit='true';if(matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver' in window))return;const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){el.classList.add('gft-ready');observer.disconnect()}},{threshold:.15});observer.observe(el);document.addEventListener('shopify:section:unload',function cleanup(event){if(event.target.contains(el)){observer.disconnect();document.removeEventListener('shopify:section:unload',cleanup)}})})};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();document.addEventListener('shopify:section:load',event=>init(event.target))})();
  } catch(e) { console.error(e); }
})();

})();
